// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__VVAWg","checked":"Switch_checked__JKpPh","switchToggleThumb":"Switch_switchToggleThumb__h0n7u","disabled":"Switch_disabled__QkAGx"};